export default "__VITE_ASSET__9t_0$L5v__"